import airbnb from '../../../../img/non-clickable-airbnb.svg';
import flipkey from '../../../../img/non-clickable-flipkey.svg';
import homeaway from '../../../../img/non-clickable-homeaway.svg';
import tripadvisor from '../../../../img/non-clickable-tripadvisor.svg';
import vrbo from '../../../../img/non-clickable-vrbo.svg';
import { ListingProvider } from '../../../api/rentalscape/__generated_types__/graphql';

const onlinePlatformIcons: Record<
  ListingProvider,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | null
> = {
  [ListingProvider.Airbnb]: airbnb,
  [ListingProvider.Vrbo]: vrbo,
  [ListingProvider.Homeaway]: homeaway,
  [ListingProvider.Flipkey]: flipkey,
  [ListingProvider.Tripadvisor]: tripadvisor,
  [ListingProvider.Unknown]: null,
};

export const ServiceProviderIcon = ({
  provider,
}: {
  provider: ListingProvider;
}) => {
  const Icon = onlinePlatformIcons[provider];

  if (!Icon) {
    return null;
  }

  return <Icon className="w-5 h-5" />;
};
